import { cn as e } from "@deputy-ai/common";
const r = [
  e("bg-red-400/90"),
  e("bg-orange-400/90"),
  e("bg-amber-400/90"),
  e("bg-yellow-400/90"),
  e("bg-lime-400/90"),
  e("bg-green-400/90"),
  e("bg-emerald-400/90"),
  e("bg-teal-400/90"),
  e("bg-cyan-400/90"),
  e("bg-sky-400/90"),
  e("bg-blue-400/90"),
  e("bg-indigo-400/90"),
  e("bg-violet-400/90"),
  e("bg-purple-400/90"),
  e("bg-fuchsia-400/90"),
  e("bg-pink-400/90"),
  e("bg-rose-400/90")
];
function l(g, b = r) {
  return b[g.charCodeAt(Math.floor(g.length / 2)) % b.length];
}
export {
  r as ColorClassNames,
  l as getColorNameByText
};
